<template lang="pug">
.countdown-overlay(:style="{ left: overlayLeft }")
  div
    .countdown-overlay__text(v-if="message.length > 0" v-html="message")
    .countdown-overlay__timer(v-if="waiting")
      | {{ $t('countDownOverlay.countdown', currentTime) }}
</template>

<script>
export default {
  name: 'CountdownOverlay',
  props: {
    message: {
      type: String,
      default: ""
    },
    times: {
      type: Number,
      default: 5,
      validator (val) {
        return val > 0
      }
    }
  },
  data () {
    return {
      currentTime: 0,
      active: true,
      waiting: true
    }
  },
  watch: {
    currentTime () {
      this.waiting = this.currentTime > 0
    }
  },
  computed: {
    overlayLeft () {
      return (this.active) ? null : "100%"
    },
  },
  created () {
    this.currentTime = this.times
    this.startTimer()
  },
  methods: {
    startTimer () {
      const interval = setInterval(() => {
        this.currentTime--

        if (this.currentTime <= 0) {
          clearInterval(interval)
          this.finish()
        }
      }, 1000)
    },
    finish () {
      this.active = false
      this.$emit('finish')
    }
  }
}
</script>

<style lang="styl" scoped>
text-color = white

.countdown-overlay
  position fixed
  top 0
  left 0
  height 100%
  width 100%
  background rgba(0, 0, 0, 0.9)
  opacity .9
  z-index 10
  transition top 0.3s, right 0.3s, bottom 0.3s, left 0.3s

  > div
    position relative
    left 0
    right 0
    bottom 0
    margin auto
    width 100%
    height 100%
    text-align center
    color text-color

    @media screen and (min-width:0px)
      > .countdown-overlay__text
        margin-top 200px
        margin-left 0.5em
        margin-right 0.5em
        font-size 1.5em
        white-space pre-wrap
      > .countdown-overlay__timer
        margin-top 100px
    @media screen and (min-width:1024px)
      > .countdown-overlay__text
        margin 3em
        font-size 4em
        white-space pre-wrap
      > .countdown-overlay__timer
        font-size 1.5em
</style>
